// eslint-disable-next-line
import React, { Component } from 'react';
import { Button, ButtonGroup, Table } from 'reactstrap';
import { ArcaHttpClientCalendar } from '../../../code/ArcaHttpClientCalendar';
import { ArcaTimeslot } from '../../../code/ArcaTimeslot';
import { ArcaCalendar } from '../../../code/Types/ArcaCalendar';
import { ArcaDate } from '../../../code/Types/ArcaDate';
import { ModalPopup } from '../ModalPopup';
import { StatusBar } from '../StatusBar';
import { CalendarDay } from './CalendarDay';
import { ArcaLink } from '../Fields/ArcaLink';

export class CalendarPanel extends Component {

    constructor(props) {
        super(props);
        var now = new Date();
        var today = new ArcaDate(now)
        var weekStart = today.GetWeekStart;

        var calendar = new ArcaCalendar();

        this.state = {
            calendarType: this.props.type === 'Walker'
                ? 'Walker'
                : 'Pet',
            arcaCalendar: calendar,
            today: today,
            weekStart: weekStart,
            statusText: null,
            isError: false,
            slots: null,
            isLoading: true,
            confirmCopyPopupVisibile: false,
            listToCopy: null,
            isSameDayRequest: false
        };
    }

    async componentDidMount() {
        await this.getSlots(this.state.weekStart)
    }

    async getSlots(weekStart) {
        this.state.weekStart = weekStart;
        await ArcaHttpClientCalendar.GetAsync(
            weekStart,
            this.props.id,
            this.state.calendarType,
            this.getSlotsSuccess.bind(this),
            ((msg) => this.setState({
                isError: true,
                statusText: msg
            })));
    }

    getSlotsSuccess(slots) {

        let calendar = new ArcaCalendar()

        if (slots.length > 0) {
            slots.map(s => {
                var slotDate = new ArcaDate(Date.parse(s.date));
                var slot = new ArcaTimeslot(s.session, slotDate, true, false, s.activityCode);
                calendar.SetSlot(slot);
            });
        }

        this.setState({
            arcaCalendar: calendar,
            statusText: null,
            isError: false,
            weekStart: this.state.weekStart,
            slots: calendar.Slots,
            isLoading: false,
            popupOpen: false
        });
    }

    onCalendarClick(date, text, selected, code) {
        var slot = new ArcaTimeslot(
            text,
            date,
            selected,
            true,
            code);

        this.state.arcaCalendar.AddOrUpdateTimeslot(slot);
        var calendar = this.state.arcaCalendar;

        this.setState({
            arcaCalendar: calendar,
            slots: calendar.Slots,
            statusText: null,
            isError: false
        });
    }

    onPreviousClick() {
        this.IncrementWeek(-1)
    }

    onNextClick() {
        this.IncrementWeek(1)
    }

    IncrementWeek(increment) {
        var newDate = this.state.weekStart.AddWeek(increment);
        this.getSlots(newDate)
    }

    async onSaveClick() {
        if (this.props.onCalendarChange)
            this.props.onCalendarChange();

        await ArcaHttpClientCalendar.SaveAsync(
            this.props.id,
            this.state.calendarType,
            this.props.type,
            this.state.arcaCalendar.GetSlots(),
            ((msg) => this.setState({
                statusText: msg,
                popupOpen: false
            })));

        await this.getSlots(this.state.weekStart);
    }

    getConfirmText() {
        return this.state.arcaCalendar.GetSummary();
    }

    showConfirmPopup() {
        this.setState({ popupOpen: true });
    }

    cancelConfirm() {
        this.setState({ popupOpen: false });
    }

    render() {
        let { weekStart, today, slots, isError, statusText } = this.state
        let { sessions, activities } = this.props

        return (
            <div>
                {this.state.isLoading
                    ? <h1>Loading ... </h1>
                    : <div>
                        <div className='centerText'>
                            <ButtonGroup>
                                <ArcaLink
                                    onClick={this.showConfirmPopup.bind(this)}
                                    text='Save' />
                                <ArcaLink
                                    colour='secondary'
                                    onClick={this.onPreviousClick.bind(this)}
                                    text='Previous' />

                                <ArcaLink
                                    colour='secondary'
                                    onClick={this.onNextClick.bind(this)}
                                    text='Next' />

                            </ButtonGroup>
                            <h3>{weekStart.MonthOfYear} {weekStart.Year}</h3>
                            <p>To guarantee your booking for this week, please ensure you have submitted your request by midday on the Friday of the previous week
                            </p>
                        </div>
                        {this.state.popupOpen
                            ? <ModalPopup
                                title='Please confirm your booking'
                                text="The following services will be added to your booking. An email will be sent confirming this. You can also view your bookings under the 'Week Plan' tab."
                                textArray={this.getConfirmText()}
                                onConfirm={this.onSaveClick.bind(this)}
                                onCancel={this.cancelConfirm.bind(this)} />
                            : null}
                        <span>
                            <Table bordered striped>
                                <tbody>
                                    {weekStart.DaysInWeek.map((i, k) =>
                                        <CalendarDay
                                            key={weekStart.DateFromDay(i).JavaScriptDate.getTime()}
                                            text={i}
                                            onClick={weekStart.DateFromDay(i).IsSameDate(today)
                                                ? () => this.setState({ isSameDayRequest: true })
                                                : this.onCalendarClick.bind(this)}
                                            date={weekStart.DateFromDay(i)}
                                            today={today}
                                            slots={slots}
                                            sessions={sessions}
                                            activities={activities} />
                                    )}
                                </tbody>
                            </Table>
                        </span>
                        <ButtonGroup>

                            {ArcaDate.Today.GetWeekStart.IsLater(weekStart)
                                ? <ArcaLink
                                    colour='secondary'
                                    width='250px'
                                    onClick={(() => this.getListToCopy())}
                                    text='Copy previous week' />
                                : null}
                        </ButtonGroup>

                        <StatusBar
                            isError={isError}
                            message={statusText} />

                        {this.state.confirmCopyPopupVisibile
                            ? <ModalPopup
                                title='Copying the previous weeks bookings ...'
                                text='This action will copy and commit all bookings from your previous 7 days. You will need to make and save adjustments once this is done ...'
                                textArray={this.getListText()}
                                onConfirm={this.copyPreviousWeek.bind(this)}
                                onCancel={(() => this.setState({ confirmCopyPopupVisibile: false }))} />
                            : null}

                        {this.state.isSameDayRequest
                            ? <ModalPopup
                                title='Same day request ...'
                                text='This request has been received after our booking deadline, you may be asked to be flexible with your booking. If this is the case a member of the team will be in touch. For live updates, please see the ‘Planning’ tab. '
                                onCancel={(() => this.setState({ isSameDayRequest: false }))} />
                            : null}
                    </div>
                }
            </div>
        );
    }

    getListText() {
        var text = new Array()
        this.state.listToCopy.map(i =>
            text.push(i.Date.DayAndMonthPretty + ' - ' + i.ActivityType + '(' + i.Session + ')')
        )

        return text
    }

    getListToCopy() {
        let { weekStart, calendarType } = this.state

        ArcaHttpClientCalendar.GetItemsToCopy(
            {
                entityId: this.props.id,
                weekStart: weekStart.ToISOString,
                entityType: calendarType
            },
            ((list) => this.gotListToCopySuccess(list)),
            ((message) => this.setState({ isError: true, statusText: message }))
        );

    }

    gotListToCopySuccess(list) {
        this.setState({
            confirmCopyPopupVisibile: true,
            listToCopy: list
        })
    }

    copyPreviousWeek() {
        let { weekStart, calendarType } = this.state

        ArcaHttpClientCalendar.CopyPreviousWeek(
            {
                entityId: this.props.id,
                weekStart: weekStart.ToISOString,
                entityType: calendarType
            },
            ((message) => this.copySuccess(message)),
            ((message) => this.setState({ isError: true, statusText: message }))
        );

        this.setState({
            confirmCopyPopupVisibile: false
        })
    }

    copySuccess(message) {
        this.getSlots(this.state.weekStart);
        this.setState({ isError: false, statusText: message })
    }
}